import { supabaseClient } from 'supabase'

/**
 * Reads the caller's administrator claim from the database.
 *
 * The predicate is evaluated server-side by Postgres under the same rule the
 * Phase 18 RLS policy on `applications` uses, so the UI guard and the database
 * agree by construction. No browser-side copy of the session is consulted —
 * anything the browser can read, an attacker with the browser can also write.
 *
 * Throws when the RPC fails. React Query turns the rejection into `isError`,
 * which the route guard denies on. Swallowing a failure into `false` would make
 * an outage indistinguishable from a genuine denial and hide it from the console.
 */
export const isClaimsAdmin = async (): Promise<boolean> => {
  const { data, error } = await supabaseClient.rpc('is_claims_admin')

  if (error) {
    throw error
  }

  // Strict comparison on purpose: null, undefined and any non-boolean the RPC
  // layer might hand back all collapse to a denial rather than a truthy pass.
  return data === true
}
